import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { FaUsers, FaKey, FaCoins, FaClock } from 'react-icons/fa';
import { adminAPI } from '../services/api';
import { toast } from 'react-toastify';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await adminAPI.getDashboard();
      setStats(response.data.data);
    } catch (error) {
      toast.error('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
        <Spinner animation="border" />
      </div>
    );
  }

  const StatCard = ({ title, value, icon, color }) => (
    <Card className="stat-card h-100">
      <Card.Body>
        <div className="d-flex align-items-center">
          <div className="stat-icon me-3" style={{ backgroundColor: color }}>
            {icon}
          </div>
          <div>
            <h6 className="text-muted mb-1">{title}</h6>
            <h3 className="mb-0">{value}</h3>
          </div>
        </div>
      </Card.Body>
    </Card>
  );

  return (
    <div>
      <h3 className="mb-4">Dashboard</h3>
      
      <Row className="g-4">
        <Col md={3}>
          <StatCard
            title="Total End Users"
            value={stats?.stats?.total_end_users || 0}
            icon={<FaUsers color="white" />}
            color="#007bff"
          />
        </Col>
        
        <Col md={3}>
          <StatCard
            title="Active Licenses"
            value={stats?.stats?.active_licenses || 0}
            icon={<FaKey color="white" />}
            color="#28a745"
          />
        </Col>
        
        <Col md={3}>
          <StatCard
            title="Trial Licenses"
            value={stats?.stats?.trial_licenses || 0}
            icon={<FaClock color="white" />}
            color="#ffc107"
          />
        </Col>
        
        <Col md={3}>
          <StatCard
            title="Total Credits Issued"
            value={stats?.stats?.total_credits_issued || 0}
            icon={<FaCoins color="white" />}
            color="#17a2b8"
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={6}>
          <Card>
            <Card.Header>Recent Licenses</Card.Header>
            <Card.Body>
              {stats?.recent_licenses?.length > 0 ? (
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Package</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.recent_licenses.map((license) => (
                      <tr key={license.id}>
                        <td>{license.User?.name}</td>
                        <td>{license.Package?.name}</td>
                        <td>
                          <span className={`badge badge-${license.status}`}>
                            {license.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-muted">No recent licenses</p>
              )}
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>Expiring Soon</Card.Header>
            <Card.Body>
              {stats?.expiring_soon?.length > 0 ? (
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Package</th>
                      <th>Expires</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.expiring_soon.map((license) => (
                      <tr key={license.id}>
                        <td>{license.User?.name}</td>
                        <td>{license.Package?.name}</td>
                        <td>{new Date(license.valid_until).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-muted">No licenses expiring soon</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
